import { render, staticRenderFns } from "./AreaPromoter.vue?vue&type=template&id=99b089e2&scoped=true"
import script from "./AreaPromoter.vue?vue&type=script&lang=js"
export * from "./AreaPromoter.vue?vue&type=script&lang=js"
import style0 from "./AreaPromoter.vue?vue&type=style&index=0&id=99b089e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b089e2",
  null
  
)

export default component.exports